import View from '@shared/components/layout-default/layout-default-router-view';
import { groups } from './groups';
import { contacts } from './contacts';
import { sip_accounts } from './sip-accounts';

export const operators = {
  path: 'operators',
  component: View,
  children: [
    {
      path: '',
      name: 'pbx.operator.index',
      redirect: {
        name: 'pbx.group.index'
      }
    },

    ...groups,
    ...contacts,
    ...sip_accounts
  ]
};
